import axios from 'axios';

import type {
  GetGalleryResT,
  PostGalleryBodyT,
  PostGalleryResT,
} from 'server/controllers';

import {
  E_GALLERY,
  type ImageAssetT,
  P_API_ARTIST,
  getConfig,
  getServerServices,
} from 'utils';

const ss = getServerServices();

export async function getGallery(artistId: string): Promise<ImageAssetT[]> {
  if (ss) return ss.getGallery(artistId);

  const res = await axios<GetGalleryResT>(`${P_API_ARTIST}/${artistId}${E_GALLERY}`);

  return res.data;
}

export async function saveGallery(
  artistId: string,
  assetIds: string[],
): Promise<ImageAssetT[]> {
  if (ss) throw Error('Client-side only');

  const config = getConfig(true);

  const res = await axios.post<PostGalleryResT>(
    `${P_API_ARTIST}/${artistId}${E_GALLERY}`,
    { _csrf: config.CSRF, assetIds } satisfies PostGalleryBodyT,
  );

  return res.data;
}
